import { LastEventTodayResponse } from './types';

export const parseGetIsLastEventToday = (
  isLastEventToday: LastEventTodayResponse,
) => isLastEventToday.is_last_event_today;
